import { partialRight } from 'lodash-es';

import { roleCafe24Master, roleManager, roleViewer } from '../consts';
import UserAuthGuard from './AuthGuard';

/**
 * AuthGuard HOC.
 */
export const AuthGuardWrap = (Child: React.ComponentType, roles: string[]) => {
  return function AuthGuardWrap() {
    return (
      <UserAuthGuard roles={roles}>
        <Child />
      </UserAuthGuard>
    );
  };
};

export const ManagerAuthGuardWrap = partialRight(AuthGuardWrap, [roleManager, roleViewer]);
export const Cafe24MasterAuthGuardWrap = partialRight(AuthGuardWrap, [roleCafe24Master]);
